{
  "styles": {
    "models": {
      "resetHeight": "Redefinir altura",
      "resetLength": "Redefinir comprimento",
      "resetWidth": "Redefinir largura",
      "attributeModel": "Edite seu modelo 3D alterando o modelo e as dimensões",
      "attributeDimensions": "Edite seu modelo 3D alterando as dimensões",
      "determineModel": "Determine o modelo por",
      "determineDimensions": "Determine o comprimento, a largura e a altura por"
    }
  },
  "exports": {
    "legendPosition": "Posição da legenda",
    "top": "Topo",
    "bottom": "Parte inferior",
    "left": "Esquerda",
    "right": "Certo",
    "layers": "Camadas",
    "all": "Todos",
    "custom": "Personalizado",
    "selectLayers": "Selecione camadas para exportar",
    "selected": "selecionado",
    "hidden": "(Oculto)",
    "none": "Nenhum"
  },
  "get_map_errors": {
    "default": "Algo deu errado",
    "not_found": "Plano não encontrado",
    "click_here_to_browser_maps": "Clique aqui para ver os planos"
  },
  "add_list_item_attribute": {
    "title": "Adicionar coluna",
    "subtitle": "Edite esse atributo de acordo com seus requisitos usando os campos abaixo",
    "column_name": "Nome da coluna",
    "column_type": "Tipo de coluna",
    "type": "Tipo de imóvel"
  },
  "list_item_properties": {
    "additional_properties": "Propriedades adicionais"
  },
  "contextMenu": {
    "import": "Importar",
    "export": "Exportar",
    "copy_layer": "Copiar camada {{ pluralise }}",
    "copy_group": "Grupo de cópias {{ pluralise }}",
    "copy_layer_and_group": "Copie a camada {{ pluraliseLayers }} e agrupe {{ pluraliseGroups }}",
    "delete": "Excluir",
    "delete_layers_title": "Excluindo camadas",
    "delete_layers_description": "Uma ou mais das camadas que você está tentando excluir estão vinculadas a outro mapa. Eles estão sendo removidos deste mapa e você pode revinculá-los a qualquer momento."
  },
  "copyOrUnlinkLayers": {
    "copy": "Copiar",
    "unlink": "Desvincular",
    "copying_layers": "Copiando camadas",
    "unlink_layer": "Desvincular uma camada",
    "linked_layers": "Camadas vinculadas",
    "original_plan": "Plano original",
    "helpbase_blurb": {
      "click": "Clique aqui",
      "link": "Primeiros passos - Knowledge Base (iventis.com)",
      "further_info": "para obter mais informações."
    },
    "copy_blurb": {
      "are_you_sure": "Tem certeza de que deseja copiar",
      "this": "isso",
      "these": "estes",
      "layer": "camada {{ pluralise }}",
      "group": "grupo {{ pluralise }}",
      "layers_and_groups": "camadas e grupos"
    },
    "unlink_info": {
      "links_to": "Essa camada está vinculada a",
      "changes_not_reflected": "Ao se desvincular do plano original, você está criando uma cópia. Quaisquer alterações feitas na camada original não serão mais refletidas em seu plano."
    },
    "unlink_blurb": "Você está copiando camadas vinculadas a mapas diferentes. Ao se desvincular do plano original, você está criando uma cópia. Quaisquer alterações feitas na camada original não serão mais refletidas em seu plano.",
    "copy_with_map_objects": "Copie a camada {{ pluralise }} com objetos do mapa"
  },
  "shareMap": {
    "title": "Plano de compartilhamento",
    "share_with_team": "Compartilhe com a equipe",
    "share_with_team_details": "Compartilhe o plano com os membros da equipe movendo-o para o “Espaço de trabalho em equipe”",
    "shared_library": {
      "title": "Compartilhe o arquivo com a equipe",
      "footer": "Os membros da equipe podem visualizar o arquivo como somente para leitura"
    },
    "shared_link": {
      "title": "Compartilhar link"
    },
    "share_link": "Gerar link",
    "share_link_details": "Crie um link temporário somente para leitura para compartilhar esse plano com usuários que não têm acesso ao Iventis",
    "share_link_generated": "Esse link expirará em {{ numberOfDays }} dias. Você pode gerar um novo link a qualquer momento."
  },
  "defaultAttribute": {
    "add": "Adicionar um valor padrão para o atributo",
    "default_field_type": "Valor padrão {{ dataFieldType }}",
    "tickbox": {
      "label": "Estado padrão da caixa de seleção",
      "on": "EM",
      "off": "DESLIGADO"
    }
  },
  "fileUpload": {
    "import_title": "Importar dados para mapear",
    "drop_file": "Solte o arquivo para fazer o upload",
    "supported_extensions": "Extensões suportadas",
    "contact_support": "Entre em contato com o suporte para arquivos maiores e outras extensões",
    "choose_file": "Escolha o arquivo",
    "max_file_size": "Tamanho máximo do arquivo {{ maxFileSize }} MB"
  }
}